// extracted by mini-css-extract-plugin
export var content = "_m9-1";
export var fullScreen = "_m9-0";